/**
 * Sign up Store
 *
 * @author minkyoung.park@emcast.com
*/

// states
const state = {
    joinStart: false,
    store : '',
    duty : '',
    responsibility : '',
    role : '',
    name : {
        first : '',
        last : '',
        fullName : ''
    },
    profile : null,
    allowPush : true,
    code : '',
    loginId : '',
    loginPw : '',
    loginRepw : '',
    terms : {
        PRIVACY_STATEMENT : '',
        COLLECTION_AND_USE : '',
        PRIVACY_CONSIGNMENT : '',
        RULES_OF_WITHDRAWAL : '',
        TERMS_OF_SERVICE : ''
    },
    socialLink : {
        type : '',
        token : '',
        socialType:'',
        userloginLanguage:''
    },
    socialId : '',
    dutyName : '',
    responsibilityName : '',
    option : {
        pushToken : '',
        pushLanguage : '',
        notificationed:''
    }
}

// getters
const getters = {
    
}

// mutations
const mutations = {
    INIT_JOIN_STORE(state) {
        state.store = ''
        state.duty = ''
        state.responsibility = ''
        state.role = ''
        state.name.first = ''
        state.name.last = ''
        state.name.fullName = ''        
        state.profile = null,
        state.allowPush = true,
        state.code = ''
        state.loginId = ''
        state.loginPw = ''
        state.loginRepw = ''        
        state.terms.PRIVACY_STATEMENT = ''
        state.terms.COLLECTION_AND_USE = ''
        state.terms.PRIVACY_CONSIGNMENT = ''
        state.terms.RULES_OF_WITHDRAWAL = ''
        state.terms.TERMS_OF_SERVICE = ''
        state.socialLink.type = ''
        state.socialLink.token = ''
        state.socialLink.socialType = ''
        state.socialLink.userloginLanguage = ''
        state.socialId = ''
        state.dutyName = ''
        state.responsibilityName = ''
        state.option.pushToken = ''
        state.option.pushLanguage = ''
        state.option.notificationed = ''
    },

    SET_JOINSTART(state, joinStart) {
        state.joinStart = joinStart
    },

    SET_ROLE(state, role) {
        state.role = role
    },

    SET_DUTY(state, duty) {
        state.duty = duty
    },

    SET_DUTYNAME(state, dutyName) {
        state.dutyName = dutyName
    },

    SET_RESPONSIBILITY(state, responsibility) {
        state.responsibility = responsibility
    },

    SET_RESPONSIBILITYNAME(state, responsibilityName) {
        state.responsibilityName = responsibilityName
    },

    SET_CODE(state, code) {
        state.code = code
    },

    SET_TERMS(state, agreeDate) {
        state.terms.TERMS_OF_SERVICE = agreeDate
        state.terms.COLLECTION_AND_USE = agreeDate
        state.terms.PRIVACY_CONSIGNMENT = agreeDate
        state.terms.PRIVACY_STATEMENT = agreeDate
        state.terms.RULES_OF_WITHDRAWAL = agreeDate
    },

    SET_NAME_FIRST(state, first) {
        state.name.first = first
    },

    SET_NAME_LAST(state, last) {
        state.name.last = last
    },

    SET_NAME_FULL(state, name) {
        state.name.fullName = name
    },

    SET_LOGINID(state, loginId) {
        state.loginId = loginId
    },

    SET_LOGINPW(state, loginPw) {
        state.loginPw = loginPw
    },

    SET_LOGINREPW(state, loginRepw) {
        state.loginRepw = loginRepw
    },
    
    SET_STORE(state, store) {
      state.store = store
    },

    SET_SOCIAL_LINK(state, socialLink) {
      state.socialLink = socialLink
    },

    SET_SOCIAL_ID(state, value) {
        state.socialId = value
    },

    SET_PUSH_NOTIFICATION(state, option) {
        state.option = option
    },
}

// actions
const actions = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
